const WHATSAPP_NUMBER = '+923348872555';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER.replace('+', '')}`;

export default function WhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2 px-4 py-3 bg-[#25D366] text-white rounded-full shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 group"
      aria-label="Chat on WhatsApp"
    >
      <span className="w-2.5 h-2.5 bg-white rounded-full animate-ping absolute -top-0.5 -right-0.5" />
      <i className="ri-whatsapp-line text-xl" />
      <span className="text-sm font-semibold whitespace-nowrap hidden sm:block">WhatsApp Us</span>
    </a>
  );
}